module.exports = __webpack_public_path__ + "static/media/t12.e01a0986.jpg";